import type { ELSModalService } from '@els/els-component-modal-react';
import { AppContext } from '../../components/app/AppProvider.component';
import { FlexLayout } from '../../components/flex/FlexLayout.component';
import { FlexLayoutModifier } from '../../components/flex/flex.constants';
import { FlexItem } from '../../components/flex/FlexItem.component';
import {
  ELSDataTable,
  ELSIcon
} from '../../components/els.components';
import React, { useContext } from 'react';
import {
  HesiExamInfoDto,
  RaasAssessmentSourceDto,
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { NotApplicableDisplay } from './remediation-student-activity.constants';
import { convertDateToMMDDYYYYHHMM } from './remediation-student-activity.utilities';

export const MultipleAssessmentSourceModalId = 'MultipleAssessmentSourceModalId';

export type MultipleAssessmentSourceModalProps = {
  hesiExamInfoDto: HesiExamInfoDto;
  modalService: ELSModalService;
};

export const MultipleAssessmentSourceModal = (props: MultipleAssessmentSourceModalProps): JSX.Element => {
  const { appState } = useContext(AppContext);
  const baseState = appState.remediationBaseState;

  const handleCancelClick = () => {
    props.modalService.closeModal(MultipleAssessmentSourceModalId);
  };
  const getSourceName = () => {
    // When the scenario comes in the future that there are multiple source types, we will likely have to make some calls to get the names of each source
    // or alter assessment source table to include sourceName column
    return NotApplicableDisplay;
  };

  const getSourceTimeSubmitted = (source: RaasAssessmentSourceDto) => {
    if (!source || !source.createdAt) {
      return NotApplicableDisplay;
    }

    return convertDateToMMDDYYYYHHMM(new Date(source.createdAt));
  };

  const getSourceScore = () => {
    // At the time of writing (FLOR-1793), we have no knowledge of how to handle multiple non-HESI source scores.
    return NotApplicableDisplay;

  };

  return (
    <div>
      <div className="c-els-modal">
        <div className="c-els-modal__window u-els-width-1o1@mobile u-els-width-1o2">
          <FlexLayout
            modifiers={[FlexLayoutModifier.SPACE_BETWEEN, FlexLayoutModifier.MIDDLE]}
          >
            <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
              <span className="u-els-font-size-h3">Plan Sources</span>
            </FlexItem>

            <FlexItem>
              <button
                type="button"
                className="u-els-anchorize u-els-debuttonize"
                onClick={() => handleCancelClick()}
              >
                <ELSIcon name="close" size="1x"/>
                <span className="u-els-hide-visually">Close</span>
              </button>
            </FlexItem>
          </FlexLayout>

          <div className="u-els-margin-top-1x u-els-margin-bottom-1x">
            This plan was generated using the results of the following assignments:
          </div>

          <ELSDataTable
            data={baseState.raasAssessmentSourceList || []}
            noWrap
            sortIconSize="1o2"
            columns={[
              {
                header: 'Name',
                field: 'sourceId',
                customRender: () => getSourceName()
              },
              {
                header: 'Time Submitted',
                field: 'createdAt',
                customRender: (source: RaasAssessmentSourceDto) => getSourceTimeSubmitted(source)
              },
              {
                header: 'Score',
                field: 'score',
                customRender: () => getSourceScore()
              }
            ]}
          >

          </ELSDataTable>
        </div>
      </div>
    </div>
  );
};
